var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit } from '@angular/core';
import { ToolEnum } from '../../models/tool.enum';
import { Select, Store } from '@ngxs/store';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { Observable } from 'rxjs';
import { ZoomCamera, SetCamera, SetCameraMode } from '../../state/camera/engine.camera.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { CenterCameraOnVisible } from '../../state/engine.actions';
import { ViewLayout } from 'src/app/view/models/view-layout.enum';
import { SetCheckedNodes } from '../../state/nodes/engine.nodes.actions';
import { HistoryService } from 'src/app/history/history.service';
import { RemoveContextLabel } from 'src/app/story/state/labels/story.labels.actions';
export class EngineCameraBarComponent {
    constructor(store, historyService) {
        this.store = store;
        this.historyService = historyService;
        this.viewLayout = ViewLayout;
        this.toolEnum = ToolEnum;
        this.showNav = true;
        this.showZoom = true;
        this.showPan = true;
        this.showResetPosition = true;
        this.showResetScene = true;
        this.expandNav = false;
    }
    ngOnInit() {
    }
    setZoom(state) {
        let zoomValue = (state === '') ? 0 : 8;
        zoomValue = (state === 'in') ? -zoomValue : zoomValue;
        this.store.dispatch(new ZoomCamera(zoomValue));
    }
    returnToChapterCamera() {
        const chapter = this.store.selectSnapshot(StoryChaptersState.getSelectedChapter);
        this.store.dispatch(new SetCamera(chapter.camera.location));
    }
    resetChapter() {
        this.returnToChapterCamera();
        this.historyService.resetChapter();
        this.store.dispatch(new SetCheckedNodes([]));
        this.store.dispatch(new RemoveContextLabel());
    }
    centerCamera() {
        this.store.dispatch(new CenterCameraOnVisible());
    }
    togglePan() {
        const mode = this.store.selectSnapshot(EngineCameraState.getPanMode) === 'pan' ? 'rotate' : 'pan';
        this.store.dispatch(new SetCameraMode(mode));
    }
    toggleNav() {
        this.expandNav = !this.expandNav;
    }
}
__decorate([
    Select(EngineCameraState.getPanMode),
    __metadata("design:type", Observable)
], EngineCameraBarComponent.prototype, "panMode$", void 0);
__decorate([
    Select(StoryChaptersState.getSelectedChapterModified),
    __metadata("design:type", Observable)
], EngineCameraBarComponent.prototype, "selectedChapterModified$", void 0);
